/* Earthbreath subscription options v1.0.1 */
(() => {
  const initializeSubscriptionOptions = () => {
    if (window.__earthbreathSubscriptionOptionsSync) return;
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    window.__earthbreathSubscriptionOptionsSync = true;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const id = `subscription-options-${event.data.sectionId}`;
      const current = document.getElementById(id);
      const next = event.data.html && event.data.html.getElementById(id);
      if (!current || !next) return;

      const selected = current.querySelector('input[name="selling_plan"]:checked');
      const fresh = next.cloneNode(true);
      if (selected) {
        const match = fresh.querySelector(`input[name="selling_plan"][value="${selected.value}"]`);
        if (match) {
          fresh.querySelectorAll('input[name="selling_plan"]').forEach((input) => {
            input.checked = false;
          });
          match.checked = true;
        }
      }

      current.replaceWith(fresh);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSubscriptionOptions, { once: true });
  } else {
    initializeSubscriptionOptions();
  }
})();
